import DealerRecallPanel from "./dealerRecallPanel.container"

export default DealerRecallPanel
